import { Injectable } from '@angular/core';
import { CustomTranslateService } from '@services/common/custom-translate.service';
import { LocalStorageKeys, StorageService } from '@services/storage/storage.service';
import { ConfigService } from 'app/app-config.service';

@Injectable({
    providedIn: 'root',
})
export class LocalizationService {
    supportedLanguages = this.configService.getConfig.supportedLanguages;

    constructor(
        private configService: ConfigService,
        private storageService: StorageService,
        private translateService: CustomTranslateService,
    ) {}

    public initializeApp(): () => Promise<void> {
        return () => {
            return new Promise<void>((resolve) => {
                this.translateService.addLangs(this.supportedLanguages);
                this.translateService.setDefaultLang(this.configService.getConfig.defaultLocale);

                const locale =
                    this.storageService.getGlobalItem<string>(LocalStorageKeys.localeUser) ??
                    this.supportedLanguages.find((lang) => lang === navigator.language.substring(0, 2).toLowerCase()) ??
                    this.configService.getConfig.defaultLocale;

                this.translateService.use(locale).subscribe(() => {
                    resolve();
                });
            });
        };
    }
}
